import { Theme } from 'baseui';
import stylesBreakpoint from 'common/styles/styles.breakpoint';
import stylesColors from 'common/styles/styles.colors';
import { themedStyled } from 'common/styles/styletron.theme';

// import colors from 'styles/colors';

export const WebSeparatorHorizontal = themedStyled<
  'div',
  { $margin: number },
  Theme
>('div', ({ $margin = 0 }) => ({
  marginLeft: `${$margin}px`,
  marginRight: `${$margin}px`,

  [`@media screen and (max-width: calc(${stylesBreakpoint.lg} - 1px))`]: {
    display: 'none',
  },
}));

export const WebSeparatorVertical = themedStyled<
  'div',
  { $margin: number },
  Theme
>('div', ({ $margin = 0 }) => ({
  marginTop: `${$margin}px`,
  marginBottom: `${$margin}px`,

  [`@media screen and (max-width: calc(${stylesBreakpoint.lg} - 1px))`]: {
    display: 'none',
  },
}));

export const SeparatorHorizontal = themedStyled<
  'div',
  { $margin: number },
  Theme
>('div', ({ $margin = 0 }) => ({
  marginLeft: `${$margin}px`,
  marginRight: `${$margin}px`,
}));

export const SeparatorVertical = themedStyled<
  'div',
  { $margin: number },
  Theme
>('div', ({ $margin = 0 }) => ({
  marginTop: `${$margin}px`,
  marginBottom: `${$margin}px`,
}));

export const TableContainer = themedStyled('div', {
  flex: 1,
  width: '100%',
  minHeight: '300px',
  flexDirection: 'column',
  display: 'flex',
});

export const Container = themedStyled('div', {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

export const FullContainer = themedStyled('div', {
  width: '100%',
});

export const HalfContainer = themedStyled('div', {
  width: '47%',

  [`@media screen and (max-width: calc(${stylesBreakpoint.lg} - 1px))`]: {
    width: '100%',
  },
});

export const SectionContainer = themedStyled('div', {
  flex: 1,
  display: 'flex',
  justifyContent: 'space-between',

  [`@media screen and (max-width: calc(${stylesBreakpoint.lg} - 1px))`]: {
    flexDirection: 'column',
  },
});

export const CardContainer = themedStyled('div', ({ $theme }) => ({
  border: `1px solid ${$theme.colors.primary}`,
  marginBottom: '16px',
}));

export const CardHeader = themedStyled('div', ({ $theme }) => ({
  border: `1px solid ${$theme.colors.primary}`,
  backgroundColor: $theme.colors.primary,
  width: '100%',
  padding: '10px 12px',
}));

export const CardContent = themedStyled<
  'div',
  {
    $noPadding?: boolean;
  },
  Theme
>('div', ({ $noPadding }) => ({
  padding: $noPadding ? '0px' : '16px',
  overflow: 'overlay',
}));

export const RightActionContainer = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
  width: '100%',
}));

export const LeftActionContainer = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  width: '100%',
  flexGrow: 1,

  [`@media screen and (max-width: calc(${stylesBreakpoint.lg} - 1px))`]: {
    marginBottom: '16px',
  },
}));

export const TopContainer = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: $theme.sizing.scale800,
  justifyContent: 'space-between',

  [`@media screen and (max-width: calc(${stylesBreakpoint.lg} - 1px))`]: {
    flexDirection: 'column',
    alignItems: 'unset',
  },
}));

export const LeftContainer = themedStyled('div', {});

export const RightContainer = themedStyled('div', {
  [`@media screen and (max-width: calc(${stylesBreakpoint.lg} - 1px))`]: {
    marginTop: '16px',
  },
});

export const RightRefreshContainer = themedStyled('div', {
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
  marginLeft: '8px',

  [`@media screen and (max-width: calc(${stylesBreakpoint.lg} - 1px))`]: {
    alignItems: 'flex-start',
    marginLeft: '0px',
    justifyContent: 'flex-start',
  },
});

export const CenteredDiv = themedStyled('div', {
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
});

export const ActionContainer = themedStyled('div', {
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
});

export const Action = themedStyled('div', {
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '4px 8px',
  borderRadius: '8px',
  ':hover': {
    backgroundColor: stylesColors.primaryLightest,
  },
});

export const DetailActionContainer = themedStyled('div', {
  display: 'flex',
  flex: 1,
  justifyContent: 'end',
  alignItems: 'end',
  marginBottom: '16px',
});

export const InputContainer = themedStyled('div', {});

export const IconContainer = themedStyled('div', {
  display: 'flex',
});

export const StyledDetailButton = themedStyled('span', ({ $theme }) => ({
  textDecoration: 'underline',
  color: $theme.colors.primaryDefault,
  padding: '0 8px',
  userSelect: 'none',
}));

export const DetailContainer = themedStyled('div', {
  display: 'flex',
  height: '100%',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});

export const styles = {
  tabPanel: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '200px',
    flexGrow: 1,
  },
  tab: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '200px',
    flexGrow: 1,
  },
  tabList: {
    minHeight: '41.48px',
  },
  tabBorder: {
    minHeight: '5px',
  },
};
